import * as types from './actionTypes';

const initialState = {
  contracts: [],
  selectedContract: null,
};

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_CONTRACT_ACTION:
      return {
        ...state,
        contracts: action.payload,
        action: action.type,
      };
      case types.SELECTED_CONTRACT:
      return {
        ...state,
        selectedContract: action.payload,
        action: action.type,
      };
      case types.SELECTED_CONTRACT_INVOICE_DATA:
      return {
        ...state,
        selectedContract: action.payload,
        action: action.type,
      };
    default:
      return state;
  }
}
